module.exports = __webpack_public_path__ + "static/img/bj.92ec29e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bj.png
// module id = YvM9
// module chunks = 1